export default function CalculateGridSize( gridEl, rowVar = undefined, colVar = undefined ) {
  
  const children = [...gridEl.children];
  
  let colCount = undefined;
  const rowStartX = children[0].getBoundingClientRect().x;
  
  children.some( (c,i) => {
    if( (i > 0 && c.getBoundingClientRect().x === rowStartX) ) {
      colCount = i;
      return true;
    }
  });
  
  colCount = colCount ?? children.length;
  
  const rowCount = Math.ceil(children.length / colCount);
  
  if( rowVar ) {
    gridEl.style.setProperty(rowVar, rowCount);
  }

  if( colVar ) {
    gridEl.style.setProperty(colVar, colCount );
  }

  children.forEach( (c,i) => {

    c.classList.remove('column-end-item');
    c.classList.remove('row-end-item');
    c.classList.remove('first-row-item');
    c.classList.remove('last-row-item');

    if( i < colCount ) {
      c.classList.add('first-row-item');
    }

    if( i > ((rowCount*colCount)-colCount-1) ) {
      c.classList.add('last-row-item');

    }

    if( (i+1) % colCount === 0 ) {
      c.classList.add('column-end-item');
    }

    if( (i+colCount+1) > children.length ) {
      c.classList.add('row-end-item');
    }

  });
  
  return {
    rowCount,
    colCount
  }
}